export default {
  videoUrl: state => state.videoUrl,
  vimeoApiLoaded: state => state.vimeoApiLoaded,
  youtubeApiLoaded: state => state.youtubeApiLoaded  
}
